export default function apiKey() {
  if (process.env.REACT_APP_DEPLOY_ENV === 'production') {
    return process.env.REACT_APP_POCAPAN_PRODUCTION_API_KEY;
  }
  if (process.env.REACT_APP_DEPLOY_ENV === 'development') {
    return process.env.REACT_APP_POCAPAN_DEVELOPMENT_API_KEY;
  }
  return process.env.REACT_APP_POCAPAN_LOCAL_API_KEY;
}
